import { render, staticRenderFns } from "./discounts-details-modal.vue?vue&type=template&id=cbe9a056&"
import script from "./discounts-details-modal.vue?vue&type=script&lang=js&"
export * from "./discounts-details-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports